<template>
  <div class="container">
    <div class="top_title">
      <router-link class="icon_back" :to="{name:'H010010'}" tag="span"></router-link>
      <p>点读课本</p>
      <span class="icon_search1" style="float: right;position: absolute;top: 0;right: 0.6rem;" @click="clickSearchBtn()"></span>
    </div>
    <div class="weui-flex top_tabs">
      <div class="weui-flex__item"><span :class="{active: tabFlag == false}" @click="clickTab(1)">推荐点读</span></div>
      <div class="weui-flex__item"><span  :class="{active: tabFlag == true}" @click="clickTab(2)">我的点读</span></div>
    </div>
    <div class="scroll_area" style="overflow: auto">
      <div v-if="dataList.length > 0" class="weui-grids" >
        <div v-for="item,index in dataList"
                     class="weui-grid" :key="item.id" @click="goToDetail(item)">
          <img :src="item.I_ICON" />
          <p class="title" style="-webkit-box-orient: vertical;">{{item.I_TITLE_1}}</p>
          <span v-if="item.I_FINISH_FLAG == 'Y' && I_FLAG == '我的'" class="isFinsh"></span>
          <span class="triangle"></span>
          <span class="level">{{item.I_LEVEL_NAME}}</span>

          <div v-if="item.I_LOCK_FLG == 'Y'" class="grid_overlayer"></div>
          <span v-if="item.I_LOCK_FLG == 'Y'" class="icon_lock"></span>
        </div>
      </div>
      <!--<p v-if="tempList.length > 0" style="height: 30px;line-height: 30px;text-align: center;color: #aaa;font-size: 0.9rem;">{{loadState}}</p>-->

      <template v-if="dataList.length == 0 && message!=''">
        <NoRecord :Message = "message"></NoRecord>
      </template>


      <p class="message" v-if="showMsg != ''">{{showMsg}}</p>
    </div>

    <!--底部导航-->
    <Footer :navs="nav"></Footer>

    <div class="overlayer" >
      <div class="modal">
        <span class="icon_close" @click="closeModal()"></span>
        <div class="modal_contents">
          <p class="title">搜索/筛选</p>
          <div class="search">
            <input class="input_search" v-model="searchInput" type="text" placeholder="输入关键词搜索(书名/级别/内容)"/>
            <span class="icon_search" @click="clickSearch1" ></span>
          </div>
          <p class="level_title">级别筛选</p>
          <div class="select_items">
              <div  class="select_item">
                <span class="selection" :class="{active:I_LEVEL_CODE == '全部'}" @click="clickSearch2('全部')">全部</span>
              </div>
              <div v-for="item in overlayerList" class="select_item">
                <span class="selection" :class="{active:I_LEVEL_CODE == item.I_LEVEL_NAME}" @click="clickSearch2(item.I_LEVEL_NAME)">{{item.I_LEVEL_NAME}}</span>
              </div>
          </div>
          <div class="weui-flex bottom_btns">
            <div class="weui-flex__item" @click="reset()">
              重置
            </div>
            <div class="weui-flex__item" @click="clickConfirm()">
              确定
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import DataRequestFactory from '@/factories/dataRequestFactory.js'
  import Footer from '../components/Footer.vue'
  import weui from 'weui.js'
  import NoRecord from '../components/NoRecord.vue'

  export default {
    name: '',
    data () {
      return {
        nav: {
          sy: true,
          jchd: false,
          yyst: false,
          wd: false,
        },
        tabFlag: false,
        dataList: [],
        I_FLAG: "",
        overlayerList:[],
        I_LEVEL_CODE: "全部",
        searchInput: "",
        tempList: [],
        listLength: 0,
        count: 1,
        loadState: "加载中......",
        message: "",
        showMsg: ""
      }
    },
    components: {
      Footer,
      NoRecord
    },
    created() {
      let params = {
        "I_FLAG":"全部",
        "I_SEARCH_FIELD":""
      }
      this.I_FLAG = '全部'
      DataRequestFactory.I110010(params).then((response) => {
        if(response.dataList.length == 0) {
          this.message = '无查询记录！'
        } else {
          this.message = ''
        }
        if(response.dataList.length <= 12) {
          this.loadState = "加载完成"
        } else {
          this.loadState = "加载中......"
        }
        this.dataList = response.dataList
        this.showMsg = response.showMsg
//        this.listLength = response.dataList.length
//        this.tempList = this.dataList.splice(0,12)
      })

      DataRequestFactory.C110010().then((response) => {
        this.overlayerList = response.dataList
      })
    },
    methods: {
      reset() {
        this.searchInput = ""
        this.I_LEVEL_CODE = "全部"
      },
      closeModal() {
        $(".overlayer").css("display","none")
      },
      clickSearchBtn() {
        $(".overlayer").css("display","block")
        this.searchInput = ""
        this.I_LEVEL_CODE = "全部"
      },
      clickSearch1() {
        let params = {
          "I_FLAG":this.I_FLAG,
          "I_SEARCH_FIELD":this.searchInput
        }
        DataRequestFactory.I110010(params).then((response) => {
          $(".overlayer").css("display","none")
          $(".scroll_area").scrollTop(0)
          if(response.dataList.length == 0) {
            this.message = '无查询记录！'
          } else {
            this.message = ''
          }
          if(response.dataList.length <= 12) {
            this.loadState = "加载完成"
          } else {
            this.loadState = "加载中......"
          }
          this.dataList = response.dataList
          this.showMsg = response.showMsg
//          this.listLength = response.dataList.length
//          this.tempList = this.dataList.splice(0,12)
        })
      },
      clickSearch2(value) {
        this.I_LEVEL_CODE = value
      },
      clickConfirm() {
        let params;
        if(this.I_LEVEL_CODE == '全部') {
          params = {
            "I_FLAG":this.I_FLAG,
            "I_LEVEL_NAME": "",
            "I_SEARCH_FIELD":this.searchInput,
          }
        } else {
          params = {
            "I_FLAG":this.I_FLAG,
            "I_SEARCH_FIELD":this.searchInput,
            "I_LEVEL_NAME": this.I_LEVEL_CODE
          }
        }
        DataRequestFactory.I110010(params).then((response) => {
          $(".overlayer").css("display","none")
          $(".scroll_area").scrollTop(0)
          if(response.dataList.length == 0) {
            this.message = '无查询记录！'
          } else {
            this.message = ''
          }
          if(response.dataList.length <= 12) {
            this.loadState = "加载完成"
          } else {
            this.loadState = "加载中......"
          }
          this.dataList = response.dataList
          this.showMsg = response.showMsg
//          this.listLength = response.dataList.length
//          this.tempList = this.dataList.splice(0,12)
        })
      },
      clickTab(value) {
        if(value == 1) {
          this.tabFlag = false
          let params = {
            "I_FLAG":"全部",
            "I_SEARCH_FIELD":""
          }
          this.I_FLAG = '全部'
          DataRequestFactory.I110010(params).then((response) => {
            $(".scroll_area").scrollTop(0)
            if(response.dataList.length == 0) {
              this.message = '无查询记录！'
            } else {
              this.message = ''
            }
            if(response.dataList.length <= 12) {
              this.loadState = "加载完成"
            } else {
              this.loadState = "加载中......"
            }
            this.dataList = response.dataList
            this.showMsg = response.showMsg
//            this.listLength = response.dataList.length
//            this.tempList = this.dataList.splice(0,12)
          })
        } else {
          this.tabFlag = true
          let params = {
            "I_FLAG":"我的",
            "I_SEARCH_FIELD":""
          }
          this.I_FLAG = '我的'
          DataRequestFactory.I110010(params).then((response) => {
            $(".scroll_area").scrollTop(0)
            if(response.dataList.length == 0) {
              this.message = '无查询记录！'
            } else {
              this.message = ''
            }
            if(response.dataList.length <= 12) {
              this.loadState = "加载完成"
            } else {
              this.loadState = "加载中......"
            }
            this.dataList = response.dataList
            this.showMsg = response.showMsg
//            this.listLength = response.dataList.length
//            this.tempList = this.dataList.splice(0,12)
        })
        }
      },
      //获取滚动条当前的位置
      getScrollTop() {
        var scrollTop = 0;
        if(document.documentElement && document.documentElement.scrollTop) {
          scrollTop = document.documentElement.scrollTop;
        } else if(document.body) {
          scrollTop = document.body.scrollTop;
        }
        return scrollTop;
      },
      //获取当前可视范围的高度
      getClientHeight() {
        var clientHeight = 0;
        if(document.body.clientHeight && document.documentElement.clientHeight) {
          clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
        } else {
          clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
        }
        return clientHeight;
      },
      //获取文档完整的高度
      getScrollHeight() {
        return Math.max(document.body.scrollHeight, $('.container')[0].scrollHeight);
      },
      goToDetail(item) {
        if(item.I_LOCK_FLG != "Y") {
          this.$router.push({name: 'H110020', params:{id: item.I_TB_NO_SYS}});
        }
      }
    },
    mounted() {
      let screenHeight = window.innerHeight;
      let fontSize = getComputedStyle(window.document.documentElement)['font-size']
      let heightDiff = screenHeight - parseInt(fontSize) * 7.8
      $(".scroll_area").css("height", heightDiff + "px"   )

//      let vm = this
//      $(".scroll_area").scroll(function(){
//        if($(this)[0].scrollTop + $(this)[0].clientHeight + 15 > $(this)[0].scrollHeight) {
//          vm.count++;
//          if(vm.count <= Math.ceil(vm.listLength/3)) {
//            if(vm.count + 1 >= Math.ceil(vm.listLength/3)) {
//              vm.loadState = "加载完成"
//            }
//            var list = vm.dataList.splice(0, 3)
//            vm.tempList = vm.tempList.concat(list);
//          }
//        }
//      })

      window.onresize = function(){
        let screenHeight = window.innerHeight;
        let fontSize = getComputedStyle(window.document.documentElement)['font-size']
        let heightDiff = screenHeight - parseInt(fontSize) * 7.8
        $(".scroll_area").css("height", heightDiff + "px"   )
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  @import '../assets/css/pages/H110010.css';
  @import '../assets/css/common.css';
</style>



// WEBPACK FOOTER //
// src/pages/H110010.vue